export const businessPlanningTableMap = {
  factory: "VAYONA_FIXEDCOST1_FACTORY_REPORT",
  onshore: "VAYONA_FIXEDCOST1_ONSHORE_REPORT",
  service: "VAYONA_FIXEDCOST1_1_MAINSERVICE_REPORT",
};

export const defaultBusinessPlanningSummary = {
  factory: [
    {
      "Category as per BP": "Facility Management Costs",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 19.42,
      Target_PerYear: 19.42,
      Baseline_PerMonth: 1.62,
      Target_PerMonth: 1.62,
      ActualValue: -7.66,
    },
    {
      "Category as per BP": "Others",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 9.32,
      Target_PerYear: 9.32,
      Baseline_PerMonth: 0.78,
      Target_PerMonth: 0.78,
      ActualValue: 0.74,
    },
    {
      "Category as per BP": "Insurance",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 5.58,
      Target_PerYear: 5.58,
      Baseline_PerMonth: 0.47,
      Target_PerMonth: 0.47,
      ActualValue: 0.76,
    },
    {
      "Category as per BP": "Payroll",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 0,
      Target_PerYear: 0,
      Baseline_PerMonth: 0,
      Target_PerMonth: 0,
      ActualValue: 6.46,
    },
    {
      "Category as per BP": "Warehouse operations & Consumables",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 4.25,
      Target_PerYear: 4.25,
      Baseline_PerMonth: 0.35,
      Target_PerMonth: 0.35,
      ActualValue: 0.43,
    },
    {
      "Category as per BP": "Repair & Maintenance",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 2.4,
      Target_PerYear: 2.4,
      Baseline_PerMonth: 0.2,
      Target_PerMonth: 0.2,
      ActualValue: 0.05,
    },
    {
      "Category as per BP": "Logistics & Intercrating, Cranes",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 4.86,
      Target_PerYear: 4.86,
      Baseline_PerMonth: 0.41,
      Target_PerMonth: 0.41,
      ActualValue: 0,
    },
    {
      "Category as per BP": "Total",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 45.83,
      Target_PerYear: 45.83,
      Baseline_PerMonth: 3.83,
      Target_PerMonth: 3.83,
      ActualValue: 0.15,
    },
  ],
  onshore: [
    {
      "Category as per BP": "Facility Management Costs",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 4.4,
      Target_PerYear: 4.4,
      Baseline_PerMonth: 0.37,
      Target_PerMonth: 0.37,
      ActualValue: 316.56,
    },
    {
      "Category as per BP": "Insurance",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 18.24,
      Target_PerYear: 4.74,
      Baseline_PerMonth: 1.52,
      Target_PerMonth: 0.4,
      ActualValue: 0.42,
    },
    {
      "Category as per BP": "Others",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 22.61,
      Target_PerYear: 22.61,
      Baseline_PerMonth: 1.88,
      Target_PerMonth: 1.88,
      ActualValue: 1.66,
    },
    {
      "Category as per BP": "Payroll",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 0,
      Target_PerYear: 0,
      Baseline_PerMonth: 0,
      Target_PerMonth: 0,
      ActualValue: 0,
    },
    {
      "Category as per BP": "Repair & Maintenance",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 0.77,
      Target_PerYear: 0.77,
      Baseline_PerMonth: 0.06,
      Target_PerMonth: 0.06,
      ActualValue: 0.46,
    },
    {
      "Category as per BP": "Warehouse operations expenses & Consumables",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 29.44,
      Target_PerYear: 5.44,
      Baseline_PerMonth: 2.45,
      Target_PerMonth: 0.45,
      ActualValue: -2.77,
    },
    {
      "Category as per BP": "Total",
      MonthYear: "Mar-2026",
      Baseline_PerYear: 75.46,
      Target_PerYear: 37.96,
      Baseline_PerMonth: 6.28,
      Target_PerMonth: 3.16,
      ActualValue: 316.33,
    },
  ],
  service: [],
};

export const normalizeSegmentKey = (value = "") => {
  const normalizedValue = value.toLowerCase();

  if (normalizedValue.includes("factory")) {
    return "factory";
  }

  if (normalizedValue.includes("onshore")) {
    return "onshore";
  }

  if (normalizedValue.includes("service")) {
    return "service";
  }

  return "factory";
};

export const formatSegmentTitle = (value = "") => {
  const segmentKey = normalizeSegmentKey(value);
  return segmentKey.charAt(0).toUpperCase() + segmentKey.slice(1);
};

export const formatTableCellValue = (value, allowZeroAsDash = false) => {
  const parsedValue = Number(value);

  if (!Number.isFinite(parsedValue)) {
    return "-";
  }

  if (allowZeroAsDash && parsedValue === 0) {
    return "-";
  }

  return parsedValue
    .toFixed(2)
    .replace(/\.00$/, "")
    .replace(/(\.\d)0$/, "$1");
};
